import useResident from 'hooks/useResident'
import { Navigate, useParams } from 'react-router-dom'
import PersonalContactForm from '../forms/PersonalContactForm'

const ResidentPersonalContactCreateScreen = ({
  testId
}: {
  testId?: string
} = {}) => {
  const { id } = useParams()

  if (!id) {
    return <Navigate to="/residents" />
  }
  const { isLoading, resident, updateResident } = useResident({ id })

  return (
    <div
      data-testid={
        testId
          ? `${testId}-personal-contact-create-screen`
          : 'personal-contact-create-screen'
      }
    >
      <PersonalContactForm
        editedIndex={undefined}
        onSubmit={updateResident}
        isLoading={isLoading}
        resident={resident}
        testId={testId}
      />
    </div>
  )
}

export default ResidentPersonalContactCreateScreen
